import {
  AMP_WIDGETS,
  COMMON_RECIPE_WIDGETS,
  COMMON_WIDGETS,
  HEALTH_MAIN_WIDGETS,
} from '~/constants/widgets';
import { useAdfoxStore } from '~/store/adfoxParams';
import { useMenusStore } from '~/store/menus';
import { useWidgetsStore } from '~/store/widgets';
import { useMascotStore } from '~/store/mascot';
import { isAmpPage, isAnyRecipePage, isHealthPath } from '~/utils/router';

export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.client) return;

  const { $logger } = useNuxtApp();
  const log = $logger.withScope('💿 app-data');

  log(`render`, { name: to.name, url: to.fullPath });

  const isRecipes = isAnyRecipePage(to.name);
  const isHealth = isHealthPath(to.path);
  const isAmp = isAmpPage(to.name);

  const widgetsStore = useWidgetsStore();
  const mascotStore = useMascotStore();
  const menuStore = useMenusStore();

  const promises: Promise<unknown>[] = [
    menuStore.fetchMenusIfNeeded(),
    useAdfoxStore().addAdfoxIpV6(),
  ];

  if (!isAmp) {
    promises.push(mascotStore.fetchMascot());
  }

  if (isRecipes) {
    promises.push(widgetsStore.fetchRecipeWidgets(COMMON_RECIPE_WIDGETS));
  } else if (isHealth) {
    promises.push(widgetsStore.fetchWidgets(HEALTH_MAIN_WIDGETS));
  } else {
    promises.push(widgetsStore.fetchWidgets(isAmp ? AMP_WIDGETS : COMMON_WIDGETS));
  }

  const responses = await Promise.allSettled(promises);

  responses
    .filter((response) => response.status === 'rejected')
    .forEach((response) =>
      log.error(response.reason.stack ?? response.reason.message ?? response.reason),
    );
});
